import * as React from 'react';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Grid, Row, Col } from 'react-flexbox-grid';

import Editor, { createValue } from '@inqool/uas-web-core/es/components/controls/Editor';

const View: React.SFC<any> = ({ handleSubmit, closeItem, description, generatedDescription }) => (
  <Grid fluid={true} style={{ height: '60vh', overflow: 'auto' }}>
    <Row>
      <Col md={12}>
        <h4>Opravdu chcete přepsat hlášení?</h4>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <h4>Původní hlášení</h4>
      </Col>
      <Col md={12}>
        <Editor id="description" label={'Původní hlášení'} readOnly={true} value={createValue(description)} />
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <h4>Generované hlášení</h4>
      </Col>
      <Col md={12}>
        <Editor
          id="generatedDescription"
          label={'Původní hlášení'}
          readOnly={true}
          value={createValue(generatedDescription)}
        />
      </Col>
    </Row>
    <Button
      label="Uložit"
      primary={true}
      style={{ margin: '15px 15px 15px 0' }}
      onClick={() => handleSubmit(closeItem)}
    />
    <Button label="Zrušit" style={{ margin: '15px 0' }} onClick={closeItem} />
  </Grid>
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormDescriptionGenerateForm.tsx